import { createSelector } from 'reselect';
import { WorkFlowConditions, ParamoOptions } from '../models';

const getMetaFields = metaData => metaData.criteriaMetaData.fields;
const getMetaConditions = metaData => metaData.criteriaMetaData.conditions;

const getConfigByMeta = createSelector(
  [
    getMetaFields,
    getMetaConditions,
  ],
  (metaFields, metaConditions) => {
    if (_.isEmpty(metaFields) || _.isEmpty(metaConditions)) return {};
    let conditions = {};
    let paramOptions = {};
    metaFields.forEach(metaField => {
      const metaConditionByType = metaConditions[metaField.dataType];
      const funcs = metaConditionByType.functions.map(func => new WorkFlowConditions(func));
      const paramOpt = metaConditionByType.compare_param_options.map(option => new ParamoOptions(option));
      const otherOpt = metaField.compareOptions.filter(option => option.display !== 'api_endpoint');
      const extraParamOpt = otherOpt.map(option => new ParamoOptions(option));
      conditions = {
        ...conditions,
        [metaField.id]: funcs
      };
      paramOptions = {
        ...paramOptions,
        [metaField.id]: [
          ...paramOpt,
          ...extraParamOpt
        ]
      };
    });
    return {
      conditions,
      paramOptions
    };
  }
);

export {
  getConfigByMeta,
};



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/reselect.js